import { userConstants } from "../../constant";
export function ndaPrice(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_NDA_PRICE_LIST:
      return action.NDA_price_list;

    default:
      return state;
  }
}
